import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function DeschideAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-987">
      <div className="max-w-7xl mx-auto px-6" data-id="element-988">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-989">
          <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={true} data-id="element-990" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-991">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-992">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-993" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-994" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-995" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-996">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-997" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-998">
            <div className="hidden lg:block" data-id="element-999">
              <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={false} data-id="element-1000" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-1001">
              <p data-id="element-1002">
                Sunt <strong data-id="element-1003">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-1004">
                Am creat cursul Deschide-ți Larg Brațele către Abundență pentru
                că am văzut un tipar care se repeta: oameni care dădeau enorm,
                la muncă, în familie, în relații, dar care nu reușeau să
                primească. Și de aceea se simțeau goi, obosiți, frustrați, chiar
                dacă pe hârtie totul arăta bine.
              </p>
              <p data-id="element-1005">
                Acest curs aduce laolaltă o meditație pentru pacea minții,
                exerciții practice simple dar puternice și tehnici testate pe
                propria mea viață. Nu e teorie. E ceva ce am trăit și am văzut
                funcționând la sute de cursanți.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-1006">
                Propoziția win-win, de exemplu, m-a ajutat personal să semnez
                contracte care mi-au adus venituri de peste 100.000 de euro în 3
                ani.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-1007">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-1008">
                  "Predau simplu, clar și structurat, cu multă iubire. Iar
                  cursanții mei spun că simt această iubire și că schimbarea
                  vine natural, fără forțare, fără presiune."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-1009" />
          </motion.div>
        </div>
      </div>
    </section>;
}